import { getCurrentSectionCode } from './layout.selectors';
import { resetSearch } from '../search/search.reset.actions';

export const SET_CURRENT_SECTION_CODE = 'navigation/SET_CURRENT_SECTION_CODE';

export const setCurrentSectionCode = sectionCode => (dispatch, getState) => {
  const currentSectionCode = getCurrentSectionCode(getState());

  if (sectionCode === currentSectionCode || !sectionCode) {
    return;
  }
  dispatch(resetSearch());
  dispatch({ type: SET_CURRENT_SECTION_CODE, sectionCode });
};
